export const EYE_LAYER_POLYGONS = {
  left: [33, 246, 161, 160, 159, 158, 157, 173, 133, 155, 154, 153, 145, 144, 163, 7],
  right: [263, 466, 388, 387, 386, 385, 384, 398, 362, 382, 381, 380, 374, 373, 390, 249]
}

export const IRIS_INDICES = {
  leftCenter: 468,
  leftRing: [469, 470, 471, 472],
  rightCenter: 473,
  rightRing: [474, 475, 476, 477]
}

export const FACE_MESH_CONTOUR_PATHS = {
  faceOval: [
    10, 338, 297, 332, 284, 251, 389, 356, 454, 323, 361, 288, 397, 365, 379, 378, 400, 377,
    152, 148, 176, 149, 150, 136, 172, 58, 132, 93, 234, 127, 162, 21, 54, 103, 67, 109
  ],
  leftEye: EYE_LAYER_POLYGONS.left,
  rightEye: EYE_LAYER_POLYGONS.right,
  leftBrow: [70, 63, 105, 66, 107, 55, 65, 52, 53, 46],
  rightBrow: [336, 296, 334, 293, 300, 285, 295, 282, 283, 276],
  noseBridge: [168, 6, 197, 195, 5, 4, 1, 19, 94, 2, 164],
  lipsOuter: [
    61, 146, 91, 181, 84, 17, 314, 405, 321, 375, 291, 308, 324, 318, 402, 317, 14, 87, 178, 88,
    95, 78
  ],
  lipsInner: [78, 191, 80, 81, 82, 13, 312, 311, 310, 415, 308, 324, 318, 402, 317, 14, 87, 178, 88, 95]
}

export const EAR_ANCHOR_INDICES = {
  leftOuter: 234,
  rightOuter: 454,
  leftTop: 127,
  rightTop: 356,
  leftBottom: 172,
  rightBottom: 397
}
